// The shop's calendar day. The shop runs on Central time; `new Date().toISOString().slice(0, 10)` is
// the UTC day, which is tomorrow after 7 PM Central (6 PM in winter), so a pallet shipped at 8 PM
// was recorded as shipped the next day (Mike, 2026-10-14: use the shop's date).

const SHOP_TZ = 'America/Chicago';
const PARTS = new Intl.DateTimeFormat('en-US', { timeZone: SHOP_TZ, year: 'numeric', month: '2-digit', day: '2-digit' });

/** Today's date in the shop's time zone, YYYY-MM-DD. */
export function shopToday(now = new Date()) {
  const p = {};
  for (const { type, value } of PARTS.formatToParts(now)) p[type] = value;
  return `${p.year}-${p.month}-${p.day}`;
}

const CLOCK = new Intl.DateTimeFormat('en-US', { timeZone: SHOP_TZ, hour: 'numeric', minute: '2-digit' });
const DAY = new Intl.DateTimeFormat('en-US', { timeZone: SHOP_TZ, month: 'short', day: 'numeric' });

/**
 * A moment as the shop's clock reads it (Central): "10:02 AM" on the shop's today, otherwise
 * "Oct 18, 10:02 AM". '' for a missing or bad time.
 */
export function shopClock(iso, now = new Date()) {
  if (!iso) return '';
  const t = new Date(iso);
  if (!Number.isFinite(t.getTime())) return '';
  const clock = CLOCK.format(t).replace(/[\u202f\u00a0]/g, ' ');
  const nowDate = now instanceof Date ? now : new Date(now);
  return shopToday(t) === shopToday(nowDate) ? clock : `${DAY.format(t)}, ${clock}`;
}
